import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import RenderSections from '@/components/probaworkflows_base_components/RenderMainSections/RenderMainSections.vue';
import FolderList from '@/components/probaworkflows_base_components/FolderList/FolderList.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { sub_entities_mixin } from '@/utils/mixins/sub_entities_mixins/sub_entities_mixin';
import EntityDocuments from "@/views/probaworkflows_base/entity/entity_applications/entity_documents/EntityDocuments.vue";
import RequestedInformationUpdate from "@/views/probaworkflows_base/entity/requested_information/requested_infomation_update/RequestedInformationUpdate.vue";
import ESigning from '@/views/probaworkflows_base/management/template_managment/e_signing/ESigning.vue';
import VerificationOverview from '@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue';
import OnboardingComplianceComponent from '@/components/probaworkflows_base_components/OnboardingComplianceChecklistComponent/OnboardingComplianceComponent.vue';
import UserProfileComponent from '@/components/probaworkflows_base_components/UserProfileComponent/UserProfileComponent.vue';
import ApplicationOverviewDetails from "../application_overview_details/ApplicationOverviewDetails.vue";
import EntityInvoiceOverview from "../entity_invoice_overview/EntityInvoiceOverview.vue";
import EntityVerificationResults from "../entity_verification_results/EntityVerificationResults.vue";
import EntityComplianceAnswers from "@/components/probaworkflows_base_components/EntityComplianceAnswers/EntityComplianceAnswers.vue";
import {
  entity_application_overview_computed,
  entity_application_overview_data,
  entity_application_overview_mounted,
  entity_application_overview_watch,
} from './entity_application_overview_config';
import { entity_application_overview_core_methods } from './entity_application_overview_core_methods';
import { entity_application_overview_share_methods } from './entity_application_overview_share_methods';
import { entity_application_overview_sub_entity_methods } from './entity_application_overview_sub_entity_methods';

export default {
  name: "EntityApplicationOverview",
  mixins: [alert_mixin, sub_entities_mixin],
  components: {
    NavigationBackButton,
    ApplicationOverviewDetails,
    EntityInvoiceOverview,
    ESigning,
    VerificationOverview,
    RequestedInformationUpdate,
    EntityDocuments,
    FolderList,
    RenderSections,
    EntityVerificationResults,
    OnboardingComplianceComponent,
    EntityComplianceAnswers,
    UserProfileComponent
  },
  data: entity_application_overview_data,
  watch: entity_application_overview_watch,
  computed: entity_application_overview_computed,
  mounted: entity_application_overview_mounted,
  methods: {
    ...entity_application_overview_core_methods,
    ...entity_application_overview_share_methods,
    ...entity_application_overview_sub_entity_methods,
  }
};
